import { defineMessages } from "react-intl";

const messages = defineMessages({
  header: {
    id: "AQ+9Ez",
    defaultMessage: "예기치 않은 오류가 발생했습니다",
  },
  content: {
    id: "/0gMCW",
    defaultMessage: "페이지를 새로고침하거나 다른 페이지로 이동하여 다시 시도해주세요.",
  },
  btnDashboard: {
    id: "9mGA/Q",
    defaultMessage: "Dashboard",
    description: "button linking to dashboard",
  },
  btnRefresh: {
    id: "ypW4Mi",
    defaultMessage: "Refresh page",
    description: "button refreshing page",
  },
  or: {
    id: "OA+fw+",
    defaultMessage: "or",
    description: "conjunction, choice between going to dashboard or refreshing page",
  },
});

export default messages;
